import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JointGiftingApprovalPayload, JointGiftingDetailsResponse } from '@shared/models';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JointGiftingApprovalService {
  readonly endpoint = `secure/gifts`;
  constructor(private http: HttpClient) {}

  sendGift(
    giftRequestData: JointGiftingApprovalPayload,
    poid: string,
  ): Observable<{ message: string }> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.post<{ message: string }>(this.endpoint, giftRequestData, { headers });
  }

  getGift(giftId: string, poid: string): Observable<JointGiftingDetailsResponse> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.get<JointGiftingDetailsResponse>(`${this.endpoint}?giftId=${giftId}`, {
      headers,
    });
  }

  addOwnerConsentForGift(giftId: string): Observable<JointGiftingDetailsResponse> {
    return this.http.post<JointGiftingDetailsResponse>(`${this.endpoint}/consent`, { giftId });
  }
}
